import { apiClient } from './apiClient.js';
import type {
  ApiResponse,
  OnboardingDocTemplateRecord,
  CreateOnboardingDocTemplateRequest,
  UpdateOnboardingDocTemplateRequest,
  AssignTemplateRolesRequest,
} from '@onboarding-dashboard/shared';

export const onboardingDocTemplatesService = {
  async list(params?: { isActive?: boolean }): Promise<ApiResponse<OnboardingDocTemplateRecord[]>> {
    const query = new URLSearchParams();
    if (params?.isActive !== undefined) query.set('isActive', String(params.isActive));
    const qs = query.toString();
    return apiClient.get<OnboardingDocTemplateRecord[]>(
      `/onboarding-doc-templates${qs ? `?${qs}` : ''}`
    );
  },

  async getById(id: string): Promise<ApiResponse<OnboardingDocTemplateRecord>> {
    return apiClient.get<OnboardingDocTemplateRecord>(`/onboarding-doc-templates/${id}`);
  },

  async create(
    data: CreateOnboardingDocTemplateRequest,
    file?: File
  ): Promise<ApiResponse<OnboardingDocTemplateRecord>> {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', data.name);
      if (data.description) formData.append('description', data.description);
      if (data.department) formData.append('department', data.department);

      if (data.driveFileUrl) formData.append('driveFileUrl', data.driveFileUrl);
      return apiClient.upload<OnboardingDocTemplateRecord>('/onboarding-doc-templates', formData);
    }
    return apiClient.post<OnboardingDocTemplateRecord>('/onboarding-doc-templates', data);
  },

  async update(
    id: string,
    data: UpdateOnboardingDocTemplateRequest,
    file?: File
  ): Promise<ApiResponse<OnboardingDocTemplateRecord>> {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      if (data.name) formData.append('name', data.name);
      if (data.description) formData.append('description', data.description);
      if (data.department) formData.append('department', data.department);
      if (data.isActive !== undefined) formData.append('isActive', String(data.isActive));
      return apiClient.upload<OnboardingDocTemplateRecord>(
        `/onboarding-doc-templates/${id}`,
        formData,
        'PATCH'
      );
    }
    return apiClient.patch<OnboardingDocTemplateRecord>(`/onboarding-doc-templates/${id}`, data);
  },

  async remove(id: string): Promise<ApiResponse<OnboardingDocTemplateRecord>> {
    return apiClient.delete<OnboardingDocTemplateRecord>(`/onboarding-doc-templates/${id}`);
  },

  async assignRoles(
    id: string,
    data: AssignTemplateRolesRequest
  ): Promise<ApiResponse<OnboardingDocTemplateRecord>> {
    return apiClient.put<OnboardingDocTemplateRecord>(
      `/onboarding-doc-templates/${id}/roles`,
      data
    );
  },
};
